import CaptchaData from "../../dto/Captcha/CaptchaData";
import ICaptchaService from "./ICaptchaService";

export default class MockCaptchaService implements ICaptchaService {
    public getCaptchaData(): Promise<CaptchaData> {
        return new Promise<CaptchaData>((resolve, reject) => {
            setTimeout(() => {
                resolve(new CaptchaData());
            }, 1000);
        });
    }
}